import { identity } from "lodash";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";

const MembersSettingPage = () => {
  const options = [
    {
      id: "account-types",
      label: "Account Categories",
      url: "/financial-setting/members/account-types/view",
    },
    {
      id: "dropdown-options",
      label: "Dropdown Options",
      url: "/financial-setting/members/dropdown-options",
    },
    {
      id: "tags",
      label: "Tags",
      url: "/financial-setting/members/tags",
    },
  ];
  return (
    <>
      <div className="col-md-4 setting-menu-sider-main">
        {options.map((item) => (
          <>
            <Link to={item.url} key={item.id}>
              <div className="p-5 bg-white text-dark setting-menu-sider">
                <div>
                  <h3>{item.label}</h3>
                </div>
                <div className="arrow-icon-menu">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-chevron-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
              </div>
            </Link>
          </>
        ))}
      </div>
    </>
  );
};

export default MembersSettingPage;
